export default {
  UNEXPECTED_ERROR:
    "申し訳ありません。予期せぬエラーが発生しました。時間を空けて再度お試しください。",
};
